import { W as WuiHyperlink$1, d as defineCustomElement$1 } from './p-ByNnp8dD.js';

const WuiHyperlink = WuiHyperlink$1;
const defineCustomElement = defineCustomElement$1;

export { WuiHyperlink, defineCustomElement };
